const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
const toast=(msg)=>{const t=$('#toast'); if(!t)return; t.textContent=msg;t.classList.add('show');clearTimeout(window.__tt);window.__tt=setTimeout(()=>t.classList.remove('show'),2200)};
$$('[data-scroll]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();$(b.dataset.scroll)?.scrollIntoView({behavior:'smooth'})}));
$$('.faq-q').forEach(q=>q.addEventListener('click',()=>q.parentElement.classList.toggle('open')));
const chatBtn=$('.chat-btn'),chatPanel=$('.chat-panel');
if(chatBtn && chatPanel) chatBtn.addEventListener('click',()=>chatPanel.classList.toggle('open'));
$$('.chat-body button').forEach(b=>b.addEventListener('click',()=>toast('Fit Specialist topic selected: '+b.textContent)));
$$('[data-modal]').forEach(b=>b.addEventListener('click',()=>$('#'+b.dataset.modal)?.classList.add('open')));
$$('.modal-close,.modal').forEach(el=>el.addEventListener('click',e=>{if(e.target===el || e.target.classList.contains('modal-close')) el.closest('.modal')?.classList.remove('open')}));
$$('.part-card').forEach(card=>card.addEventListener('click',()=>{$$('.part-card').forEach(c=>c.classList.remove('active'));card.classList.add('active');toast((card.dataset.part||'Part')+' selected')}));
$$('.concern-choice,.concern-card').forEach(card=>card.addEventListener('click',()=>{card.parentElement.querySelectorAll('.active').forEach(c=>c.classList.remove('active'));card.classList.add('active');toast('Showing fit guidance for: '+(card.dataset.concern||card.textContent.trim().split('\n')[0]))}));
$$('.chip').forEach(chip=>chip.addEventListener('click',()=>{chip.parentElement.querySelectorAll('.chip').forEach(c=>c.classList.remove('active'));chip.classList.add('active');toast('Reviews filtered: '+chip.textContent)}));

let qStep=0, answers=[];
const questions=[
 {q:'What matters most to you?',a:['A closer, more secure everyday fit','Maximum parting freedom','High ponytails and updos','The easiest beginner setup']},
 {q:'How much time do you want to spend installing?',a:['Under 2 minutes','5–10 minutes is fine','I enjoy styling and customizing']},
 {q:'What did your last wig do wrong?',a:['Sides lifted','It slipped or shifted','It felt too tight','I needed too much glue']}
];
function renderQuiz(){const body=$('#quizBody');if(!body)return;if(qStep>=questions.length){body.innerHTML=`<div class="eyebrow">Your fit match</div><h2>Start with the 11×6 Fit System.</h2><p class="muted">Based on your priorities, we would lead with flexible parting, a curved cap concept, and a glueless-friendly everyday setup.</p><a class="btn" href="/collections/all">View Recommended Wigs</a>`;return;}const q=questions[qStep];body.innerHTML=`<div class="eyebrow">Find My Fit · ${qStep+1}/3</div><h2>${q.q}</h2><div class="quiz-progress"><i style="width:${(qStep+1)/3*100}%"></i></div><div class="quiz-options">${q.a.map(x=>`<button class="quiz-option">${x}</button>`).join('')}</div>`;$$('.quiz-option',body).forEach(b=>b.addEventListener('click',()=>{answers.push(b.textContent);qStep++;renderQuiz()}));}
$$('[data-quiz]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();qStep=0;answers=[];renderQuiz();$('#quizModal')?.classList.add('open')}));

$$('[data-quick-url]').forEach(b=>b.addEventListener('click',()=>{const card=b.closest('.product-card');const body=$('#quickBody');if(!body)return;const img=card.querySelector('img')?.src||'';body.innerHTML=`<div class="eyebrow">Quick View</div><img src="${img}" style="width:100%;height:330px;object-fit:cover;object-position:center 18%;border-radius:10px"><h2 style="font-size:36px;margin-top:20px">${card.dataset.name||''}</h2><div class="stars">★★★★★</div><p class="price">${card.dataset.price||''}</p><p class="muted">11×6 fit concept · glueless-friendly wear · flexible parting.</p><a class="btn" href="${b.dataset.quickUrl}">VIEW FULL DETAILS</a>`;$('#quickModal')?.classList.add('open')}));

$$('.thumb').forEach(t=>t.addEventListener('click',()=>{$$('.thumb').forEach(x=>x.classList.remove('active'));t.classList.add('active');const main=$('#mainPdpImage');if(main)main.src=t.dataset.src}));

// Shopify variant button logic
const productRoot=$('[data-zv-product]');
if(productRoot){
  const variantsEl=$('#ZVVariantsJson');
  let variants=[];try{variants=JSON.parse(variantsEl?.textContent||'[]')}catch(e){}
  const idSelect=$('[data-variant-select]',productRoot);
  const priceEl=$('[data-product-price]',productRoot);
  const addBtn=$('[data-product-submit]',productRoot);
  const selected=[];
  function syncVariant(){
    $$('.zv-option-label input:checked',productRoot).forEach(i=>selected[Number(i.dataset.optionIndex)]=i.value);
    const variant=variants.find(v=>v.options.every((o,i)=>o===selected[i])) || variants.find(v=>v.available) || variants[0];
    if(!variant)return;
    if(idSelect)idSelect.value=variant.id;
    if(priceEl)priceEl.textContent=(window.Shopify?.currency?.active||'$')==='USD' ? '$'+(variant.price/100).toFixed(2) : (variant.price/100).toFixed(2);
    if(addBtn){addBtn.disabled=!variant.available;addBtn.textContent=variant.available?'ADD TO BAG — '+(priceEl?.textContent||''):'SOLD OUT';}
    const sticky=$('#stickyVariant');if(sticky)sticky.textContent=selected.filter(Boolean).join(' · ');
  }
  $$('.zv-option-label input',productRoot).forEach(i=>i.addEventListener('change',syncVariant));syncVariant();
}
const sticky=$('#stickyAtc');if(sticky){window.addEventListener('scroll',()=>sticky.classList.toggle('show',window.scrollY>700));}
$$('[data-light]').forEach(b=>b.addEventListener('click',()=>{$$('[data-light]').forEach(x=>x.classList.remove('active'));b.classList.add('active');const img=$('#lightImage');if(img)img.src=b.dataset.light;toast(b.textContent+' view')}));


document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-zv2-part]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var parent = btn.parentElement;
      parent.querySelectorAll('[data-zv2-part]').forEach(function(x){x.classList.remove('active')});
      btn.classList.add('active');
    });
  });
  document.querySelectorAll('[data-zv2-concern]').forEach(function(btn){
    btn.addEventListener('click', function(){
      btn.parentElement.querySelectorAll('[data-zv2-concern]').forEach(function(x){x.classList.remove('active')});
      btn.classList.add('active');
    });
  });
  document.querySelectorAll('.zv2-faq-q').forEach(function(q){
    q.addEventListener('click', function(){ q.parentElement.classList.toggle('open'); });
  });
  document.querySelectorAll('[data-zv2-thumb]').forEach(function(t){
    t.addEventListener('click', function(){
      var main = document.getElementById('ZV2MainImage');
      if(main && t.dataset.zv2Thumb){ main.src = t.dataset.zv2Thumb; }
    });
  });
  document.querySelectorAll('[data-zv2-minus]').forEach(function(b){
    b.addEventListener('click', function(){
      var input=b.parentElement.querySelector('input'); input.value=Math.max(1,(parseInt(input.value)||1)-1);
    });
  });
  document.querySelectorAll('[data-zv2-plus]').forEach(function(b){
    b.addEventListener('click', function(){
      var input=b.parentElement.querySelector('input'); input.value=(parseInt(input.value)||1)+1;
    });
  });
  document.querySelectorAll('.zv2-option button').forEach(function(b){
    b.addEventListener('click', function(){
      b.parentElement.querySelectorAll('button').forEach(function(x){x.classList.remove('active')});
      b.classList.add('active');
    });
  });
});
document.addEventListener('DOMContentLoaded', function () {
  // Fix collection Quick View
  document.querySelectorAll('[data-zv2-quick]').forEach(function (button) {
    button.type = 'button';

    button.addEventListener('click', function (event) {
      event.preventDefault();

      var card = button.closest('.zv2-product-card');
      var modal = document.getElementById('quickModal');
      var body = document.getElementById('quickBody');

      if (!card || !modal || !body) return;

      var image = card.querySelector('img');
      var title = card.querySelector('h3');
      var price = card.querySelector('strong');
      var detailsLink =
        card.querySelector('a.zv2-mini-dark') ||
        card.querySelector('a[href*="/products/"]');

      body.innerHTML =
        '<div class="eyebrow">Quick View</div>' +
        (image
          ? '<img src="' +
            image.src +
            '" style="width:100%;height:360px;object-fit:cover;object-position:center 20%;border-radius:10px">'
          : '') +
        '<h2 style="font-size:34px;margin:20px 0 8px">' +
        (title ? title.textContent.trim() : '') +
        '</h2>' +
        '<p class="price">' +
        (price ? price.textContent.trim() : '') +
        '</p>' +
        '<p class="muted">11×6 wide parting · HD lace · glueless-friendly fit.</p>' +
        (detailsLink
          ? '<a class="btn" href="' +
            detailsLink.href +
            '">VIEW FULL DETAILS</a>'
          : '');

      modal.classList.add('open');
    });
  });

  // Fix real Shopify variant selection
  var form = document.getElementById('ZV2ProductForm');
  var variantsScript = document.getElementById('ZV2Variants');

  if (!form || !variantsScript) return;

  var variants = [];

  try {
    variants = JSON.parse(variantsScript.textContent || '[]');
  } catch (error) {
    console.error('Zelaver Wigs variant JSON error:', error);
    return;
  }

  var optionGroups = Array.from(form.querySelectorAll('.zv2-option'));
  var variantIdInput = form.querySelector('[data-zv2-variant-id]');
  var priceElement = document.querySelector('.zv2-buybox .zv2-price');
  var addButton = form.querySelector(
    '.zv2-buy-actions button[type="submit"]'
  );
  var stockElement = form.querySelector('.zv2-qty span');

  function formatMoney(cents) {
    var currency =
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      'USD';

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-US',
        {
          style: 'currency',
          currency: currency
        }
      ).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function selectedOptions() {
    return optionGroups.map(function (group) {
      var activeButton = group.querySelector('button.active');

      return activeButton
        ? activeButton.dataset.value || activeButton.textContent.trim()
        : '';
    });
  }

  function syncVariant() {
    var selected = selectedOptions();

    var variant = variants.find(function (item) {
      return item.options.every(function (optionValue, index) {
        return String(optionValue) === String(selected[index]);
      });
    });

    if (!variant) {
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = 'UNAVAILABLE';
      }

      if (stockElement) {
        stockElement.textContent = 'Unavailable';
      }

      return;
    }

    if (variantIdInput) {
      variantIdInput.value = variant.id;
    }

    var formattedPrice = formatMoney(variant.price);

    if (priceElement) {
      priceElement.textContent = formattedPrice;
    }

    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available
        ? 'ADD TO BAG — ' + formattedPrice
        : 'SOLD OUT';
    }

    if (stockElement) {
      stockElement.textContent = variant.available
        ? 'In stock'
        : 'Sold out';
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  optionGroups.forEach(function (group) {
    group
      .querySelectorAll('button[data-zv2-option]')
      .forEach(function (button) {
        button.addEventListener('click', function () {
          group.querySelectorAll('button').forEach(function (item) {
            item.classList.remove('active');
          });

          button.classList.add('active');
          syncVariant();
        });
      });
  });

  syncVariant();
});